import React, { useEffect } from 'react';
import './styles.css';
const src = require('~assets/img/header/lilla.svg');
const Placeholder = () => {
  useEffect(() => {
    const baseLoading = document.getElementById('baseLoading');

    if (baseLoading) {
      baseLoading.remove();
    }
  }, []);
  return (
    <>
      <div className="header">
        <img alt="Lilla" src={src} className="header--image" />
      </div>
      <div className="mainbody">
        <div className="hidden-mobile mainbody--menu">
          <div className="xload-placeholder xload-radius xload-h-24 xload-w-150 mainbody--menu--item"></div>
          <div className="xload-placeholder xload-radius xload-h-24 xload-w-150 mainbody--menu--item"></div>
          <div className="xload-placeholder xload-radius xload-h-24 xload-w-150 mainbody--menu--item"></div>
          <div className="xload-placeholder xload-radius xload-h-24 xload-w-150 mainbody--menu--item"></div>
          <div className="xload-placeholder xload-radius xload-h-24 xload-w-150 mainbody--menu--item"></div>
          <div className="xload-placeholder xload-radius xload-h-24 xload-w-150 mainbody--menu--item"></div>
        </div>
        <div className="mainbody--mainbanner">
          <div className="xload-main-banner xload-placeholder xload-radius"></div>
        </div>
        <div className="mainbody--flashsale padding-mobile">
          <div className="mainbody--flashsale--header">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 mainbody--menu--item"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 mainbody--menu--item"></div>
          </div>
          <div className="mainbody--flashsale--content">
            <div className="item xload-w-4 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-250"></div>
            </div>
            <div className="item xload-w-4 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
            <div className="item xload-w-4 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
            <div className="item xload-w-4 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
          </div>
        </div>
        <div className="mainbody--categories padding-mobile">
          <div className="mainbody--categories--header">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 mainbody--menu--item"></div>
          </div>
          <div className="mainbody--categories--content">
            <div className="item xload-w-3 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
            </div>
            <div className="item xload-w-3 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
            </div>
            <div className="item xload-w-3 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
            </div>
          </div>
        </div>
        <div className="mainbody--brands padding-mobile">
          <div className="mainbody--brands--header">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 mainbody--menu--item"></div>
          </div>
          <div className="mainbody--brands--content">
            <div className="item xload-w-5 xload-w-padding mainbody--brands--content--item">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-120"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding mainbody--brands--content--item">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-120"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding mainbody--brands--content--item">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-120"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding mainbody--brands--content--item">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-120"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding mainbody--brands--content--item">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-120"></div>
            </div>
          </div>
        </div>
        <div className="mainbody--categories padding-mobile">
          <div className="mainbody--categories--header">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 mainbody--menu--item"></div>
          </div>
          <div className="mainbody--categories--content">
            <div className="item xload-w-3 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
            </div>
            <div className="item xload-w-3 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
            </div>
            <div className="item xload-w-3 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
            </div>
          </div>
        </div>
        <div className="mainbody--products padding-mobile">
          <div className="mainbody--products--header">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 mainbody--menu--item"></div>
          </div>
          <div className="mainbody--products--content">
            <div className="item xload-w-5 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
            <div className="item xload-w-5 xload-w-padding">
              <div className="xload-placeholder xload-radius xload-w-full xload-h-150"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-full xload-mt-10"></div>
              <div className="xload-placeholder xload-radius xload-w-50-full xload-mt-10"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer hidden-mobile">
        <div className="footer-divider">
          <div className="xload-placeholder xload-w-full xload-h-100"></div>
        </div>
        <div className="footer-content xload-flex">
          <div className="xload-w-3">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
          </div>
          <div className="xload-w-3">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-flex">
              <div className="xload-w-padding">
                <div className="xload-placeholder xload-radius xload-h-50 xload-w-100"></div>
              </div>
              <div className="xload-w-padding">
                <div className="xload-placeholder xload-radius xload-h-50 xload-w-100"></div>
              </div>
              <div className="xload-w-padding">
                <div className="xload-placeholder xload-radius xload-h-50 xload-w-100"></div>
              </div>
            </div>
            <div className="xload-flex xload-mt-10">
              <div className="xload-w-padding">
                <div className="xload-placeholder xload-radius xload-h-50 xload-w-100"></div>
              </div>
              <div className="xload-w-padding">
                <div className="xload-placeholder xload-radius xload-h-50 xload-w-100"></div>
              </div>
              <div className="xload-w-padding">
                <div className="xload-placeholder xload-radius xload-h-50 xload-w-100"></div>
              </div>
            </div>
          </div>
          <div className="xload-w-3">
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
            <div className="xload-placeholder xload-radius xload-h-24 xload-w-250 xload-h-margin"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Placeholder;
